export type SkillLoadingPhase = "resolving" | "settled";

export function skillLoadingStatus(phase: SkillLoadingPhase): string {
  return phase === "resolving" ? "Checking Skills..." : "Thinking...";
}
